/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AdminUserResponseDto } from '../models/AdminUserResponseDto';
import type { AdminUserSegmentsResponseDto } from '../models/AdminUserSegmentsResponseDto';
import type { AdminUsersResponseDto } from '../models/AdminUsersResponseDto';
import type { PromoteUserDto } from '../models/PromoteUserDto';
import type { SetUserRoleDto } from '../models/SetUserRoleDto';
import type { SuspendUserDto } from '../models/SuspendUserDto';
import type { UserSuspensionStateDto } from '../models/UserSuspensionStateDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AdminUsersService {
    /**
     * Get all users with their roles
     * Get a paginated list of all users with optional filtering, sorting, and search
     * @param page Page number (1-indexed)
     * @param limit Number of items per page
     * @param search Search by name, email, or ID
     * @param role Filter by role (admin, user, moderator, developer, system)
     * @param status Filter by status (Active, Recently Active, Inactive, Long Gone)
     * @param device Filter by device type (iOS, Android, Web)
     * @param sortBy Sort field (id, name, email, role, createdAt, updatedAt, joinDate, lastActive, plan, businesses). lastActive sorts by the rendered activity value: newest device session (revoked included), falling back to last login then signup.
     * @param sortOrder Sort direction (asc, desc)
     * @param userIds Comma-separated list of user IDs to fetch (for activity-based queries). When provided, pagination and other filters are ignored.
     * @param plan Filter by plan bucket derived from persisted subscription state. `paying` = pro or business excluding trials; `trial` = active subscription still inside its introductory window.
     * @param suspended Filter by suspension state (true = suspended accounts only, false = non-suspended only). Boolean param instead of overloading `status`, which already carries the activity-derived status.
     * @param signedUpAfter Only users who signed up at or after this ISO 8601 timestamp
     * @param signedUpBefore Only users who signed up at or before this ISO 8601 timestamp
     * @param activeAfter Only users last active at or after this ISO 8601 timestamp
     * @param activeBefore Only users last active at or before this ISO 8601 timestamp (dormant-style queries)
     * @param internal Filter by internal accounts (true = @monday.com/@taka.ai emails only, false = exclude them)
     * @returns AdminUsersResponseDto Users retrieved successfully
     * @throws ApiError
     */
    public static adminUsersControllerGetAllUsersV1(
        page: number = 1,
        limit: number = 50,
        search?: string,
        role?: string,
        status?: string,
        device?: string,
        sortBy: string = 'updatedAt',
        sortOrder: string = 'desc',
        userIds?: string,
        plan?: 'free' | 'trial' | 'pro' | 'business' | 'paying',
        suspended?: boolean,
        signedUpAfter?: string,
        signedUpBefore?: string,
        activeAfter?: string,
        activeBefore?: string,
        internal?: boolean,
    ): CancelablePromise<AdminUsersResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/users',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'role': role,
                'status': status,
                'device': device,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
                'userIds': userIds,
                'plan': plan,
                'suspended': suspended,
                'signedUpAfter': signedUpAfter,
                'signedUpBefore': signedUpBefore,
                'activeAfter': activeAfter,
                'activeBefore': activeBefore,
                'internal': internal,
            },
        });
    }
    /**
     * Get one-click segment counts for the users list
     * Counts for the segments bar: all, paying, in-trial, new this week, dormant paying (paying with no activity 14d), suspended, internal. Derived from persisted state only.
     * @returns AdminUserSegmentsResponseDto Segment counts
     * @throws ApiError
     */
    public static adminUsersControllerGetUserSegmentsV1(): CancelablePromise<AdminUserSegmentsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/users/segments',
        });
    }
    /**
     * Get user statistics for dashboard
     * @returns any Returns user statistics including totals, active users, new users, etc.
     * @throws ApiError
     */
    public static adminUsersControllerGetUserStatsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/users/stats',
        });
    }
    /**
     * Get all admin users
     * @returns any Returns all users with admin privileges
     * @throws ApiError
     */
    public static adminUsersControllerGetAllAdminsV1(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/users/admins',
        });
    }
    /**
     * Set user role by email
     * @param requestBody
     * @returns any User role updated successfully
     * @throws ApiError
     */
    public static adminUsersControllerSetUserRoleV1(
        requestBody: SetUserRoleDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/users/role',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Promote a user to admin
     * @param requestBody
     * @returns any User promoted to admin
     * @throws ApiError
     */
    public static adminUsersControllerPromoteUserV1(
        requestBody: PromoteUserDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/users/promote',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get a single user by ID
     * @param userId
     * @returns AdminUserResponseDto Returns user information with role and device data
     * @throws ApiError
     */
    public static adminUsersControllerGetUserByIdV1(
        userId: string,
    ): CancelablePromise<AdminUserResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/users/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                404: `User not found`,
            },
        });
    }
    /**
     * Hard-delete a user account (admin-initiated)
     * Same purge as the user-facing self-serve delete: scrubs RevenueCat customer attributes (purchase history retained), drops GCS files, revokes sessions, removes solo-owned businesses. Returns 409 if the user owns a business that has other members. Returns 404 if the user does not exist.
     * @param userId
     * @returns void
     * @throws ApiError
     */
    public static adminUsersControllerDeleteUserV1(
        userId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/admin/users/{userId}',
            path: {
                'userId': userId,
            },
            errors: {
                404: `User not found`,
                409: `Owner of a multi-member business — transfer ownership first`,
            },
        });
    }
    /**
     * Get detailed device information for a user
     * @param userId
     * @returns any Returns detailed device session information for the user
     * @throws ApiError
     */
    public static adminUsersControllerGetUserDevicesV1(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/admin/users/{userId}/devices',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * Suspend a user account (full freeze)
     * Sets suspendedAt + optional reason. Enforcement: the JWT strategy rejects every request from a suspended user on their next request, and scheduled publishing excludes businesses this user owns. Idempotent — suspending an already-suspended user returns the current state.
     * @param userId
     * @param requestBody
     * @returns UserSuspensionStateDto Suspension state
     * @throws ApiError
     */
    public static adminUsersControllerSuspendUserV1(
        userId: string,
        requestBody: SuspendUserDto,
    ): CancelablePromise<UserSuspensionStateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/users/{userId}/suspend',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Target user is an admin`,
                404: `User not found`,
            },
        });
    }
    /**
     * Lift a user suspension
     * Clears suspendedAt and suspendedReason. Idempotent — unsuspending a non-suspended user is a no-op.
     * @param userId
     * @returns UserSuspensionStateDto Suspension state
     * @throws ApiError
     */
    public static adminUsersControllerUnsuspendUserV1(
        userId: string,
    ): CancelablePromise<UserSuspensionStateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/users/{userId}/unsuspend',
            path: {
                'userId': userId,
            },
            errors: {
                404: `User not found`,
            },
        });
    }
    /**
     * Reset user onboarding flow to version 0
     * @param userId
     * @returns any User onboarding flow reset successfully
     * @throws ApiError
     */
    public static adminUsersControllerResetUserOnboardingV1(
        userId: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/admin/users/{userId}/reset-onboarding',
            path: {
                'userId': userId,
            },
        });
    }
}
